import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import {GamesOpenSessionsComponent} from "./games-open-sessions.component";
import {TopImageComponent} from "../top-image/top-image.component";
import {LobbyHeaderComponent} from "../lobby-header/lobby-header.component";
import {useServices} from "../../react-hooks/use-services.hook";
import {reaction} from "mobx";

export const GamesOpenSessionsPageComponent: React.FC = observer(() => {
    const services = useServices();
    const stickyHandlerRef = useRef(services.stickyHandlerFactory.createStickyHandler());

    let historyPageConfig = services.configuration.data.historyPage;
    if (!historyPageConfig) {
        return null;
    }


    useEffect(() => {
        const stickyHandler = stickyHandlerRef.current;
        return () => {
            stickyHandler.dispose();
        }
    }, []);


    useEffect(() => {
        const reactionDispose = reaction(() => services.user.isAuthorized,
            (isAuthorized) => {
                if(!isAuthorized) {
                    services.user.waitForAutoLogin().then(() => {
                        if(!services.user.isAuthorized) {
                            services.location.goHome();
                        }
                    })
                }
            }, {
                fireImmediately: true
            })

        return () => {
            reactionDispose();
        }
    }, [services.location, services.user]);

    return (
        <>
            <TopImageComponent image={historyPageConfig.topImage}/>
            <LobbyHeaderComponent
                title={services.translation.translate('OPEN_BETS')}
                stickyHandler={stickyHandlerRef.current}
                showSearchIcon={false}
            />

            <GamesOpenSessionsComponent/>
        </>

    )
})